
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/services/strategy",
      function () {
        return require("private-next-pages/services/strategy.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/services/strategy"])
      });
    }
  